<template>
    <div ref="container"></div>
</template>

<script>
export default {
    name: "VueRecaptcha",
    props: {
        sitekey: { type: String, required: true }
    },
    emits: ["verify", "expire"],
    data() {
        return { widgetId: null };
    },
    mounted() {
        this._tryRender();
    },
    methods: {
        _tryRender() {
            if (window.grecaptcha && window.grecaptcha.render) {
                this.widgetId = window.grecaptcha.render(this.$refs.container, {
                    sitekey: this.sitekey,
                    callback: (token) => this.$emit("verify", token),
                    "expired-callback": () => this.$emit("expire")
                });
            } else {
                setTimeout(this._tryRender, 200);
            }
        },
        reset() {
            if (window.grecaptcha && this.widgetId !== null) {
                window.grecaptcha.reset(this.widgetId);
            }
        }
    }
};
</script>
